// 用到的所有图标都要在此文件中手动引入，具体名称可查看ant.design中的icon图标

export { default as SearchOutline } from '@ant-design/icons/lib/outline/SearchOutline';
export { default as DownOutline } from '@ant-design/icons/lib/outline/DownOutline';
export { default as CaretDownOutline } from '@ant-design/icons/lib/outline/CaretDownOutline';
export { default as ArrowLeftOutline } from '@ant-design/icons/lib/outline/ArrowLeftOutline';
export { default as UpOutline } from '@ant-design/icons/lib/outline/UpOutline';
export { default as LoadingOutline } from '@ant-design/icons/lib/outline/LoadingOutline';
export { default as LeftOutline } from '@ant-design/icons/lib/outline/LeftOutline';
export { default as RightOutline } from '@ant-design/icons/lib/outline/RightOutline';
export { default as CaretDownFill } from '@ant-design/icons/lib/fill/CaretDownFill';
export { default as CloseCircleFill } from '@ant-design/icons/lib/fill/CloseCircleFill';